module.exports = __webpack_public_path__ + "static/media/portfolio-img8.bd46a530.jpg";